function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 80.7299,
  height: 78,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4185_2995)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5259 65.0001C13.9775 65.0001 12.6847 64.4991 11.6475 63.497C10.6104 62.4949 10.0918 61.2458 10.0918 59.7497V28.0005C10.0918 26.5044 10.6104 25.2553 11.6475 24.2532C12.6847 23.2512 13.9775 22.7501 15.5259 22.7501H30.2743V18.2497C30.2743 16.7541 30.7929 15.5053 31.83 14.5032C32.8672 13.5012 34.16 13.0001 35.7084 13.0001H45.0226C46.5711 13.0001 47.8639 13.5012 48.901 14.5032C49.9382 15.5053 50.4567 16.7541 50.4567 18.2497V22.7501H65.2051C66.7535 22.7501 68.0463 23.2512 69.0835 24.2532C70.1207 25.2553 70.6392 26.5044 70.6392 28.0005V41.644C70.1044 41.3147 69.5676 41.0281 69.0288 40.7844C68.4895 40.5406 67.9051 40.3126 67.2755 40.1002V28.0005C67.2755 27.4171 67.0815 26.9377 66.6936 26.5624C66.305 26.1875 65.8089 26.0001 65.2051 26.0001H15.5259C14.9221 26.0001 14.426 26.1875 14.0375 26.5624C13.6495 26.9377 13.4555 27.4171 13.4555 28.0005V59.7497C13.4555 60.3331 13.6495 60.8125 14.0375 61.1879C14.426 61.5627 14.9221 61.7501 15.5259 61.7501H40.6178C40.7428 62.3459 40.8765 62.9044 41.0189 63.4255C41.1613 63.946 41.3337 64.4709 41.5361 65.0001H15.5259ZM33.638 22.7501H47.093V18.2497C47.093 17.6668 46.899 17.1877 46.5111 16.8124C46.1226 16.4375 45.6264 16.2501 45.0226 16.2501H35.7084C35.1046 16.2501 34.6085 16.4375 34.2199 16.8124C33.832 17.1877 33.638 17.6668 33.638 18.2497V22.7501ZM60.548 71.5001C56.8002 71.5001 53.6209 70.2386 51.0101 67.7155C48.3987 65.193 47.093 62.1212 47.093 58.5001C47.093 54.8791 48.3987 51.8073 51.0101 49.2847C53.6209 46.7617 56.8002 45.5001 60.548 45.5001C64.2958 45.5001 67.4751 46.7617 70.0859 49.2847C72.6973 51.8073 74.003 54.8791 74.003 58.5001C74.003 62.1212 72.6973 65.193 70.0859 67.7155C67.4751 70.2386 64.2958 71.5001 60.548 71.5001ZM61.8414 57.9752V49.1255H59.2546V59.025L66.0982 65.6379L67.9356 63.8626L61.8414 57.9752Z",
  fill: "white"
}));

function SvgWorkHistoryLarge(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 78,
    viewBox: "0 0 81 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4185_2995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 78
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHistoryLarge);
export default __webpack_public_path__ + "static/media/workHistoryLarge.d76e634713b2383cfdde06cccd5a9b93.svg";
export { ForwardRef as ReactComponent };